
const digest = '9d6dc877ac431bb048763fb1d4bc0104d09d20e8fb59848ec4b5f5587cab61b2';
const classes = {"wrapper":"_wrapper_ff4vg_1"};
const css = `._wrapper_ff4vg_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  